<template>
  <div class="OPCargo flex-jc-bt">
    <div class="flex-60 left-side">
      <SpCard class="card">
        <div class="text-left title">
          <p class="fs-bold">{{ $l('PleasedefinethecompaniesthatplaytheroleofCPsigningrelatedtothiscargo') }}</p>
          <p class="fs-int tip">{{ $l('Canonlybeselectedindividully') }}</p>
        </div>
        <div class="flex-jc-bt">
          <div class="flex-50" />
        </div>
        <div v-for="(option,index) in options" :key="`options-${index}`" class="item">
          <SpRadio :disabled="formData.opOwnerships?.filter(n=>n.typeId)?.length>0&&formData.opOwnerships?.[index]?.typeId!==option.id || !canOperated"
                   :name="`opOwnerships.${index}.typeId`" :value="option.id">
            <span class="fs-int radio-label">{{ option.name }}</span>
          </SpRadio>
          <div class="flex-jc-bt">
            <div class="flex-48">
              <SpSelect :name="`opOwnerships.${index}.corpIds`"
                        multi-select class="mg-t-10"
                        :options="companies"
                        :disabled="formData.opOwnerships?.filter(n=>n.typeId)?.length>0&&formData.opOwnerships?.[index]?.typeId!==option.id || !canOperated"
                        type="warn" height="35" />
            </div>
            <div class="flex-50">
              <div class="flex-jc-bt">
                <div class="flex-50">
                  <div class="flex-al-center">
                    <p class="fs-int" style="width: 50px">{{ $l('From') }}</p>
                    <!--            <SpSelect class="flex-40" :height="35" /> -->
                    <SpDatePicker :name="`opOwnerships.${index}.activatedDate`"
                                  height="35"
                                  class="flex-1"
                                  :disabled="formData.opOwnerships?.filter(n=>n.typeId)?.length>0&&formData.opOwnerships?.[index]?.typeId!==option.id || !canOperated"
                                  type="grayBorder1" />
                  </div>
                </div>
                <div class="flex-50">
                  <div class="flex-al-center">
                    <p class="fs-int text-center" style="width: 50px">{{ $l('To') }}</p>
                    <!--            <SpSelect class="flex-40" :height="35" /> -->
                    <SpDatePicker :name="`opOwnerships.${index}.expiredDate`"
                                  class="flex-1"
                                  height="35"
                                  :disabled="formData.opOwnerships?.filter(n=>n.typeId)?.length>0&&formData.opOwnerships?.[index]?.typeId!==option.id || !canOperated"
                                  type="grayBorder1" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="item"> -->
        <!--          <SpRadio v-model="type" value="lading"><span class="fs-int">{{ $l('Weseethefullnameasbelowchartershipsviaback') }}</span></SpRadio> -->
        <!--          <SpSelect class="mg-t-10" type="warn" height="35" /> -->
        <!--          <div class="flex-al-center from-to"> -->
        <!--            <p class="flex-10 fs-int">{{ $l('From') }}</p> -->
        <!--            <SpSelect class="flex-40" :height="35" /> -->
        <!--            <p class="flex-10 fs-int text-center">{{ $l('To') }}</p> -->
        <!--            <SpSelect class="flex-40" :height="35" /> -->
        <!--          </div> -->
        <!--        </div> -->
        <!--        <div class="item"> -->
        <!--          <SpRadio v-model="type" value="lading"><span class="fs-int">{{ $l('Weseethefullnameasbelowchartershipsonbehalfofheadcharterersortradersexclusively') }}</span></SpRadio> -->
        <!--          <SpSelect class="mg-t-10" type="warn" height="35" /> -->
        <!--          <div class="flex-al-center from-to"> -->
        <!--            <p class="flex-10 fs-int">{{ $l('From') }}</p> -->
        <!--            <SpSelect class="flex-40" :height="35" /> -->
        <!--            <p class="flex-10 fs-int text-center">{{ $l('To') }}</p> -->
        <!--            <SpSelect class="flex-40" :height="35" /> -->
        <!--          </div> -->
        <!--        </div> -->
        <div class="mg-t-20">
          <div class="flex-jc-center">
            <!--          <SpButton v-if="!canOperated" :label="$l('reclaimRight')" :width="400" :height="110" bold :circle-radius="1" @click="openOp" /> -->
            <SpButton circle bold type="back" :width="240" :height="75" class="mg-r-40">{{ $l('Back') }}</SpButton>
            <SpButton html-type="submit" circle bold :width="240" :height="75">{{ $l('Submit') }}</SpButton>
          </div>
        </div>
      </SpCard>
      <p class="card-tip none-style">{{ $l('TheabovecompaniesthatneedtobeselectedmustbeinitializedintheCompaniesandStaffControlpageinadvance') }}</p>
      <p class="card-tip none-style">{{ $l('Ifyoucantfindthecompanyyouneedherepleasesolveitasfollows') }}</p>
      <p class="card-tip">{{ $l('Method1informHRordesigneetofillintherequiredcompany') }}</p>
      <p class="card-tip">{{ $l('Method2addtherequiredcompanyintheCompanydefinitionpageonyourown') }}</p>
    </div>
    <div class="flex-38 right-side sp-color-bg-4 text-left">
      <p class="fs-bold mg-b-60">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</p>
      <p class="fs-int upload-title">{{ $l('CopyofSignedContractConcerned') }}</p>
      <SpUploadGroup :business-id="formData.businessId" file-type="ownership/vicegerent/cargo/contract" accept="image" />
      <p class="fs-int upload-title">{{ $l('CopyofConfirmationLetter') }}</p>
      <SpUploadGroup :business-id="formData.businessId" file-type="ownership/vicegerent/cargo/confirmation" accept="image" />
      <p class="fs-int upload-title">{{ $l('Others') }}</p>
      <SpUploadGroup :business-id="formData.businessId" file-type="ownership/vicegerent/cargo/other" accept="image" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpCard from '@/components/common/SpCard.vue'
import SpButton from '@/components/common/SpButton.vue'
import SpRadio from '@/components/common/SpRadio.vue'
import SpSelect from '@/components/common/SpSelect.vue'
import SpSelectOption from '@/components/common/SpSelectOption.vue'
import SpUploadGroup from '@/components/common/SpUploadGroup.vue'
import SpDatePicker from '@/components/common/SpDatePicker'
export default {
  name: 'OPCargo',

  nameSpace: 'cargoOwner.cargo.RightClaim.OPCargoVUE',

  components: {
    SpDatePicker,
    SpCard,
    SpButton,
    SpRadio,
    SpSelect,
    SpSelectOption,
    SpUploadGroup
  },

  props: {
    canOperated: {
      type: Boolean,
      default: false
    },

    options: {
      type: Array,
      default: () => []
    },

    companies: {
      type: Array,
      default: () => []
    },

    formData: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ['openOp'],
  setup (props, ctx) {
    const openOp = () => {
      ctx.emit('openOp')
    }
    return {
      openOp
    }
  }
}
</script>

<style scoped lang="less">
.OPCargo{
  padding: @gap 0;
  .left-side{
    .card{
      .title{
        p{
          margin:0;
        }
        .tip{
          opacity: 0.6;
          font-size: 14px;
          padding: @gap/4 0 @gap 0;
        }
      }
      .item{
        .radio-label{
          white-space: pre-wrap;
        }
        text-align: left;
        margin-top: @gap/2;
        .from-to{
          margin-top: @gap/2;
        }
      }
    }
    .card-tip{
      text-align: left;
      text-indent: 2em;
      font-size: 14px;
      font-family: Arial;
      font-weight: 400;
      color: #000000;
      opacity: 0.5;
    }
    .none-style{
      margin:0;
    }
    .buttons{
      margin-top: @gap*3;
      width:60%;
    }
  }
  .right-side{
    box-sizing: border-box;
    padding: @gap;
    .upload-title{
      opacity: 0.6;
      margin-top: @gap;
    }
  }
}
</style>
